<template>
  <div class="d-flex fd-column ITEM p-b-2">
    <img
        class="IMAGE m-b-3"
        :src="step.image"
        :alt="step.altText"
    /><div class="h5 text-bold p-x-1:mo m-b-1 ">{{step.title}}</div>
    <p class="p-x-1:mo">{{step.description}}</p>
  </div>
</template>

<script>

export default {
  name: 'how-it-works-step',
  props: {
    step: {
      type: Object,
      require: true,
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.TITLE {
  text-align: left;
  font-size: 22px;
}
.ITEM {
   max-width: 395px;
   text-align: left;
}
.IMAGE {
  align-self: center;
  width: 100%;
  height: auto;
}
</style>
